import { useState } from "react";
import { Props_SnippetAccordion } from "./Accordion.props";
import { motion, AnimatePresence } from "framer-motion";
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'

const Accordion = (props: Props_SnippetAccordion) => {
  const { accordionTitle, repeatable_accordionRow } = props;
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const accordionTitleClass =
    "snippet-accordion__title " +
    (accordionTitle?.visibility?.value === "visible" ? "" : "accessible-heading");

  return (
    <section className="snippet-accordion" id={accordionTitle?.snippetid?.value || ""}>
      <div className="snippet-accordion__container">
        {accordionTitle?.text?.value && (
          <h2 className={accordionTitleClass}>{accordionTitle.text.value}</h2>
        )}

        <div className="snippet-accordion__row-container">
          {repeatable_accordionRow.map((row, idx) => (
            <div
              className={
                "snippet-accordion__row" +
                (openIndex === idx ? " snippet-accordion__row--open" : "")
              }
              key={"accordion-row-" + idx}
            >
              <button
                className="snippet-accordion__row-title"
                aria-expanded={openIndex === idx}
                aria-controls={`accordion-content-${idx}`}
                id={`accordion-header-${idx}`}
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                type="button"
              >
                {row.title?.value}
              </button>
              <AnimatePresence initial={false}>
                {openIndex === idx && (
                  <motion.div
                    id={`accordion-content-${idx}`}
                    className="snippet-accordion__content-container"
                    role="region"
                    aria-labelledby={`accordion-header-${idx}`}
                    initial="collapsed"
                    animate="open"
                    exit="collapsed"
                    variants={{
                      open: { height: "auto", opacity: 1 },
                      collapsed: { height: 0, opacity: 0 },
                    }}
                    transition={{ duration: 0.3, ease: "easeInOut" }}
                    style={{ overflow: "hidden" }}
                  >
                    {row.text?.value && (
                      <div className="snippet-accordion__text">{CompileMarkdown(row.text.value)}</div>
                    )}
                    {(row.linkhref?.value && row.linktext?.value) && (
                      <a
                        href={row.linkhref.value}
                        className="snippet-accordion__link attrax-button"
                        aria-label={row.linktext.value}
                      >
                        {row.linktext.value}
                      </a>
                    )}
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Accordion;